import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ImageProvider } from '../../providers/image/image';
import { LocationProvider } from '../../providers/location/location';

/**
 * Generated class for the HomePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
})
export class HomePage {

  title = 'My first AGM project';
  lat = -23.838703;
  lng = -55.416115  ;

  constructor(public image:ImageProvider, private geo: LocationProvider) {
    this.geo.getLocationObservable().subscribe(dados=> {
      if(dados.coords && dados.coords.latitude) {
        this.lat= dados.coords.latitude
        this.lng= dados.coords.longitude;
      }
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad HomePage');
  }

  public chamaCamera() {
   
    this.image.puxaCamera();
  }



}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts